<template>
  <div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      aria-labelledby="selfPortraitTitle"
      width="642.7" height="613.3" viewBox="0 0 2163.2 2064.2"
      @click="generateCurvyShape"
      class="img-fluid">
      <title id="selfPortraitTitle">Animated SVG drawing of Dan Devorkin</title>
      <defs>
        <clipPath id="a">
          <path :d="pathD" style="fill: none" :style="blobStyle"/>
        </clipPath>
      </defs>
      <path :d="pathD" fill="#c3dae0" :style="blobStyle"/>
      <circle v-for="n in 5" cx="0" cy="0" r="30" fill="#c3dae0" :style="circleCoordinateStyles(n)"/>{{ circleCoordinateStyles(1) }}
      <g style="clip-path: url(#a)">>
        <path d="M1346 1560.1s34 100 27 176-24 134.6-50 154c-8 6 14.3 19.5-13 39-7 5-11 25-10 43s-4 3-8 16-.5 33.7-17 60c-5 8 1 50-12 81s-11 76-11 76h-251v-46s-14 33-12 46-295 3-295 3 0-70-2-92-5-57-3-95-14.3-52.3 10-135c5-17 20-81 11-97s-21.7-16.6-14-75c2-15 1-32 32-66 0 0 34-18 29-23s16 20 30 17 17 20 17 20l16-9s97 31 181 2 335-130 345-95z" fill="#9a9a8b"/>
      </g>
      <path d="M1044.5 512.6s9 7 13 40 34 49 12 98-97 100-155 87-68-35-68-35 11-61 0-72M760 471.1s-10-76-7-79c0 0 2-13 1-20 0 0 6-19 5-25s8-66 26-73 60-35 120-25 77 14 77 14 5-2 5 10c0 0-4 50 21 75 16 16 13 65 13 65s2 43 0 49-8 42.8-34 48c-10 2-7 19-15 14s-14.7-32.6-51-23c-15 4-28 3-37 9s-33-9-47-7-51 18-37 49-3 12-3 12-25.2-27.3-33-66z" fill="#f6c2ac"/>
      <path d="M845.5 260.6s-60-21-73 23-8 52-14 65-.5 23.5-5.5 44.5 6 105 7 125 42 62 42 62 11 9 8-17-2-41 18-42 22-37 22-37l8-71s-13-24-4-30-18 1-14-16 2-22 14-32 6-72-8.5-74.5z" fill="#edbcab"/>
      <path d="M1058 665.1c-27 15-90 44-133 48s-73-19-78-24-15-21 0-33c0 0-13-1-12 20 0 0-6 9-11 14s-11.8 45.1-44 88c-9 12-5 175-16 201s-7 127-4 136-1 36 8 51 18.1 39.9 6 64c-3 6 11 16 17 34s1 97 5 127 24 103 19 132-6 66-10 69-16 13-12 17 11 1 13 0 1 20 5 24-11 13 0 22 25 38 156 23c0 0 7-32-4-78s0-156 0-156 4-132 4-145 5-224 5-226 15-115 21-125 12-51 24-60-16-42 0-68 34-91 34-91l23-65z" fill="#b3c5e2"/>
      <path d="M694 282.1c10 8 16 8 17 12s-5 13 5 21 20 16 22 10c0 0 7 10 5 16s2 10 0 13 0 13 2 16-1 12 1 16 4 14 4 14-.8 48.4 6 62c1 2 1 29 2 33l2-24s-10-76-7-79c0 0 2-13 1-20 0 0 6-19 5-25s8-66 26-73 60-35 120-25 77 14 77 14 5-2 5 10c0 0-4 50 21 75 16 16 13 65 13 65s2 43 0 49-8 42.8-34 48c-10 2-7 19-15 14s-14.7-32.6-51-23c-15 4-28 3-37 9s-33-9-47-7-51 18-37 49-3 12-3 12-25.2-27.3-33-66c-2-10-12 39 12 72s65 68 70 81 61 29 91 12 127-121 120-149-14.8-59.9-11-83c2-12-11.6-33.3 6-49 9-8 22-11 22-11s-9.8-28.5 0-44c7-11-5-32-5-32s21-3 21-6 10 10.9-7 23c-7 5 21-8 18-22 0 0 19-13 19-28 0 0-10 14-15 17 0 0 20-29 15-34 0 0-22 36-36 31s-25-17-19-31 26-29 20-36c0 0-13 21-22 22a29 29 0 01-15-2s5.8-9.6 13-12c3-1-10-1-16 5-2 2-1-7 5-9 0 0-8 1-9 5 0 0 0-7 3-8 0 0-5-1-6 4s-5-16-1-20c0 0-9 4-8 13 0 0-3-7-2-10s31-79-40-103c0 0 51 34 28 68 0 0 1-26-10-37 0 0 8 34 0 36-4 1-6.9-32-23-32 0 0 17 21 6 36 0 0-3-45-20-45s-18-18-43-18c0 0 23 20 17 25 0 0-29-32-68-21 0 0 32 12 30 21 0 0-44-21-60-15s-11 21-11 21-18.4 19.6-32 15c-3-1-7-8-14-5s-8.3-.6-17 8c-3 3-4 5-3 10s-7.6 15-12-7c-1-5-3-8-7-8s-2 9-5 11-6 5-9-4a24.2 24.2 0 010-16s-7 4-4 15c0 0-5-16-2-20 0 0-14.2 14.8 3 32 3 3-1 14-9 16s-15.4 15.3-9 25c2 3-8 16 0 23s17 13 13 17-9 4-20-12c0 0-2 15 7 27 0 0-15-4-18 2s-11 12-1 20zm249.5 255.8c-5.9 6.6-27.4 28.7-50.5 32.2-13 2-39 2-51-6a34.1 34.1 0 01-13.7-19.7 1.4 1.4 0 01.9-1.7c4.8-1.5 23.2-6.7 39.8-2.6 4 1 20.7 1.1 36-4 3-.9 12.5-5.7 37.7-.5a1.4 1.4 0 01.8 2.3z" fill="#875c4a"/>
      <path d="M1050.1 382.2zM740 413.1c5.5 2.7 12 22 14 31 5.6 25.1 32 36 67 25s24-64 29-64a157.4 157.4 0 0022-2s11-1 7 6 7 20 13 31 24 21 29 21c32.1 0 35-4 47-8 22.3-7.4 17-46 16-54s8-11 8-11c12.8-3.6 51.4-5.6 58.1-5.9-4.7-.5-9.1-10.1-9.1-10.1l-54 2s-37-3-61 1-43 20-47 19-6-1-8 0-6 5-12 2-17 2-23-1c-39.2-19.6-97 3-97 3s-1 14 1 15zm165-26c21-8 48-12 64-3 0 0 21.1 17.2 4 57-3 7-24 17-52 13-7-1-27-17-31-31s-6-28 15-36zm-144 15c36-18 69-1 69-1s10 7 11 14c4.3 30-11 45-15 47-41.6 20.8-58-4-61-9-11.7-19.5-8-49-4-51z" fill="#747a90"/>
      <path d="M830.3 545.4c.9 3.5 3.5 10.7 13.2 17.2 12 8 36.5 9.5 49.5 7.5 23.1-3.5 44.6-25.6 50.5-32.2a1.4 1.4 0 00-.8-2.3c-25.2-5.2-34.7-.4-37.7.5-15.3 5.1-32 5-36 4-16.6-4.1-33 2.1-37.8 3.6a1.4 1.4 0 00-.9 1.7z" fill="#995364"/>
      <path d="M943.1 537c-31.6 13.6-76.6 21.6-114.8 10.6-4.4-1.3.2-6 .2-6s80-13 115.3-9.5c0 0 6.8 1.7-.7 4.9zm-53.3 38.6c21.8-5.5 41.7-24 41.7-24s-47 22-94 10c0 0 42 16.6 52.3 14z" fill="#fff"/>
      <path d="M824.4 545c3 5.9 10.2 19.7 15.6 25.1 7 7 44 25 72 8 25.5-15.4 36.9-33.4 39.5-44.8a2.6 2.6 0 00-2.5-3.2c-10 .1-41.4-2.6-49-1s-23 4-36 1c-10.4-2.4-30.5 7.9-38 10.8a3.1 3.1 0 00-1.6 4.1zm6.8-1.3c4.8-1.5 21.2-7.7 37.8-3.6 4 1 20.7 1.1 36-4 3-.9 12.5-5.7 37.7-.5a1.4 1.4 0 01.8 2.3c-5.9 6.6-27.4 28.7-50.5 32.2-13 2-37.5.5-49.5-7.5-9.7-6.5-12.3-13.7-13.2-17.2a1.4 1.4 0 01.9-1.7z" fill="#d68693"/>
      <path d="M857.5 413.6a28.5 28.5 0 013 25c-5 14-5.3 45.5 2 51 4 3 15.5 10.5 13.5 13.5s-6 7-23 0-16-6-18-4-4-13 0-19 7.6-7.1 11-38c1-9 6-28 11.5-28.5z" fill="#dba795"/>
      <path d="M1056 382.1s16.1-14.6 29-6c3 2 6 16 3 25-1 3 .9 16.3-3 24-2 4-4 43-14 53-4 4-3 18-10 20s-15 19-15-20c0-4-16-48 10-96z" fill="#f6c2ac"/>
      <path d="M1053 417.1c-1.4.2-10.4 12.2-3 27 2 4 0 17-5 20 0 0 2.5 1.5 10-6 3-3 4 2 9-3s13-41-11-38zm23-24a5.2 5.2 0 011.1-5.2 22.5 22.5 0 002.9-3.8c1-2 9 4 4 22s-5 36-6 39c0 0 1.5-42.1-2-52z" fill="#dba795"/>
      <path d="M1008.4 880.2c-1.8-20.2-5.6-85.7 20.6-89.1 0 0-11-51 28-94 0 0-2-41 8-57s-1-89-6-88-5-26-2-29 22 5 32 25 17 13 21 10 17 10 18 13 9 7 12 14 27 6 36 6 37 1 43 33c0 0-16-6-25-2s-48 18-68 36-34 47-40 53-18 25-18 36-4 31 0 38c0 0-31.4 78.3-53.6 97.5a3.6 3.6 0 01-6-2.4zM847 653.1s-15 8-12 23c0 0-10 11-11 18s-18 48-19 49-18.3 27.3-24 33c-3 3-4 184-14 198s-4-7-8-12-5-16-7-24-24-88-22-118c0 0-24 2-26 5s-6-36-10-43-24.2-99.2 66-132c11-4 40.2-21.1 53-19 6 1 11-9 11-9z" fill="#ca2d4c"/>
      <path d="M730 820.1s-24 2-26 5-2 6-3 12 57 198 58 227 1 62-9 75c0 0 19.8-19.8 12-97-1-10 4-38 2-60s-30-78-34-162zm296-27a1.2 1.2 0 011.8 1.3c-2.7 7.3-8.8 25.1-8.8 37.7 0 8-1 37 0 47s-6.5 5.4-8.5 4.3a1.6 1.6 0 01-.6-.8c-1.2-6.5-12.4-69.1 16.1-89.5z" fill="#e3eeff"/>
      <path d="M744.5 1046.6s-2 111-7 146 .7 365.3 54 392c4 2 8 10 8 10a5.9 5.9 0 005.5-2.5c2-3 4-20 4-26s8-47 7-59-10-77-14-82-9.5-65.9-8-77c1-7 1-40 0-53s1-28-9-44-13.6-15.8-10-23c1-2 11-24-1-49s-12-28-12-35 1.6-35.9-4-47c-1-2-1-21-1-21z" fill="#375272"/>
      <path d="M965 1608.1c8 35 4 65 1 72s19.5 81.6 39 84c8 1 14-14 20-17s30-15 34-19 19 5 33-1 122-58 151-67 71-45 78-58 34-25 33-50-11-64 5-70 15 7 26 0 28-11 50-14 39.7-33.1 34-54c-3-11-8-19-8-29s1-18-1-22 23-3 29-11 24-25 34-29 42-58 50-70 26-25 29-34 56-67 57-80 0-28-5-38 2-22-7-32-3-15-12-23 2.9-14.8-15-26c-8-5-99-131-102-140s-22-27-22-31-5-20-23-25-20-40-35-50c0 0 1.7-28.2-27-39-8-3-5-33-16-39s-17-21-31-30c0 0-9-7-19-6s-20-10-35-10c-6 0-22-13.1-41-10-6 1-3.9-14-53-14-8 0-19-5-19-5s-49 16-67 34-32 40-41 52-21 25-21 36-3 37 0 42-44 90-54 98-27.9 46.2-25 64c1 6-13 42-16 108s-7 98-7 121 3 120 0 145-2 134-4 150-5 102 3 137zm358-403c-4-6 17.8-17.9 8-35-4-7 16-26 9-43s4-54 7-63 9.4-36.7 11.5-45.5a1.2 1.2 0 012.1-.4c4.1 5.1 15 18.5 21.4 20.9 8 3 10 10 16 17s15 22 26 27-4.3 14.2 16 20c7 2 6 19 23 13 0 0-4 7-5 13s-14.4 11.7-16 21c-1 6-10.3-2.8-16 17-2 7-7 13.3-10 22-2 6-12.1-4.1-19 20-2 7-12 3-17 8s-15 16-27 22-5-3-16 9-10 0-10 0-1-9-4-15 10-13.1 0-28zm-629-488s-13 2-9 17-32 13-30 66 2 101 0 122 19 46 19 58-12 26-5 33 13 4 15-6c0 0 4 7 0 27s2 78 1 92 7 26 4 42-10 56-8 68-17 61-23 73-21 26-26 33 3 65 13 80-1 39 0 45 33 54 41 62 20 15 27 17 6.3 15.2 23 20c7 2-3 24 0 33s39 48 48 50 0 15 6 18 4.4 32.1 21 21c6-4 4-84 0-85s-19 15-10-8-7-17-15-47-49-239-44-254 7-187 12-205 8-9-17-117-36-105.8-36-128c0-7 5-11 3-19s-4-37-10-43-5-17-5-27 5-38 5-38z" fill="#416498"/>
      <g fill="#375272">
        <path d="M1337.5 928.6s18-17 23-43c0 0-7 46-12 54s15.5-8.5 24.5-19.5c0 0-13 26-18 32s15 6 30-5 67-51 75-68c0 0-10 28-79 81 0 0-5.4 9.2 27-7 14-7 2 18-9 27 0 0 4 6 25-9s40-31 47-41-1.2 16.8-44 51c-10 8-5 23 4 19s1 6 6 9 34.2-3.8 48-20c6-7-8 24-14 30s18 19 27 15 7 14-5 26 38-8 48-17c0 0 12.8 8-10 25-4 3 57-18 82 0 0 0-21-5-41 0s-52 11-52 12 22-1 29 3c0 0-20-1-29 2 0 0 46-1 65 12 0 0-62.1-8.3-75-4-3 1 24 0 23 6s-15 3-15 19-1 23-23 23-12 4 5 8 58 21 20 22c0 0-17-13.8-48-20-5-1 60 24.4 77 50 2 3-8 6-42-8s-46-9-49-9 19 25-5 17-33-13-1 8 17.1 24.9-13 12c-7-3-15-3-15 5 0 0-17-11-31-13 0 0 10-10 11-16s11-7 12-8 11.6-34.4 23-39c5-2 12-17 19-21s-5.6 2.2 2-13c2-4-1 1-7 1s-6-8-8-9-12-3-16-13-1-11-7-12-15-12-17-16-6-7-10-9-4-13-13-17-17-24-23-26c0 0-2 28-14 47 0 0-9 45-6 62s-10 38-9 43 1.8 23.8-8 40c-3 5 9.2-1.5 3 23-1 4 4 20 4 24s-12-2-20 10-.8 23.3-17 20c-5-1-11 5-11 5s-2-23 3-20 3-4 3-7 13-10 16-24 12-37 15-41-2-21 1-31 10-18 3-15-2-5 0-9-10 6-2-8 16-42 15-48-3-8-13-13-4-28-8-34-4-11.8-4-21c0-4-7-3-1-24s15-65 16-75 14-5 14-5z"/>
        <path d="M1394 1216.1s11 1 12 4-2 13-9 15-9 14-19 12a233.2 233.2 0 01-25-7c-3-1 9-3 14-10s7.1-7.4 12-14c3-4 10-4 15 0zm-52 33s32-4 46 7 29 31 27 39-12 22-7 40-5 25-11 19-6-22-11-25-8.6-11.6-5-26c1-4-11-18-24-18s-31-16-34-17a83.8 83.8 0 00-10-2s-2.8-5.5 4.1-8.8 11.9-3.2 11.9-3.2 2-4 13-5zm97 180s-9.2-43.6-36-57c-8-4-24-19-27-28s-23-22-29-19-3 12 9 27 22.7 33.1 24 40c1 5 8 6.3 19 21 3 4 23 25 33 23s7-7 7-7zm-75 37s2-6-6-4-7.2-.4-3-11c2-5-4 6-11 2s-11-5-18 7-3 4 6 3 2 1-2 7-13.8 10.8-6 16c3 2 3 3 3 6s1 0 10-6 23-23 27-20zm-232-809s-4 26-3 42 2 53 3 60-6 20-10 14 0-25-4-26 9-31-5-31c0 0-16-5-19 6s-9 5-9 11 0 15-4 21-2 19-7 31-.8 23.7-13 45c-4 7-13 60-11 77s15 20 21 19 66-19 71-26 17-78 14-108 12 5 14 14 12.7 64.5 22 77c6 8-9 7-3 20s-2 13 2 20 12 10 14 18 0 18-20 23 9 41 27 41 42-28 41-36-3.6-27.3 5-36c6-6 5-16 6-6s-1 12-6 15 0 21 3 23 13 2 13-8 1-58 0-97-11-115-15-119-5.2 42.4-16 47c-7 3 2-24 3-66s4-54 9-59-14 6-23 25-34-8-44-21-16-39-26 1-9-28-9-28z"/>
      </g>
    </svg>
  </div>
</template>

<script>

export default {
  name: 'SelfPortrait',
  components: {

  },
  props: {
    currentMouseX: Number,
    currentMouseY: Number,
    currentMouseMomentum: Number
  },
  data () {
    return {
      pathCoordinates: [],
      pathD: '',
      vertixCountFactor: 0.5,
      radius: 800,
      angle: 0,
      centerX: 1000,
      centerY: 1000,
      shapeWeirdness: 50,
      colors: [
        '#c3dae0',
        '#b65855',
        '#375272',
        '#F7FAFC',
        '#b65855'
      ],
      circleColors: [
        '#D6DCD0',
        '#C3DAE0',
        '#D9C2C4',
        '#C9F7F7'
      ]
    }
  },
  computed: {
    blobStyle () {
      const style = {
        animationPlayState: this.currentMouseMomentum === 0 ? 'paused' : 'running',
        transitionDuration: '1s'
      }
      return style
    }
  },
  methods: {
    circleCoordinateStyles (n) {
      const color = this.colors[n - 1]
      const deg = 360 * this.vertixCountFactor
      n += deg
      const x = (this.radius * Math.cos(n) + this.centerX) + this.getRandomRadiusModifier() + 10
      const y = (this.radius * Math.sin(n) + this.centerY) + this.getRandomRadiusModifier() + 10
      const style = {
        animationPlayState: this.currentMouseMomentum === 0 ? 'paused' : 'running',
        transform: `translate(${x}px, ${y}px) scale(${Math.random() * -1})`,
        transitionDuration: '1s',
        fill: color,
        transitionTimingFunction: 'cubic-bezier(0, 0.75, 1, 1)'
      }
      return style
    },
    // https://medium.com/better-programming/random-svg-blob-shape-generator-e3d5b9a55f50
    generateCoords () {
      for (let i = 0; i < 2 * Math.PI; i += this.vertixCountFactor) {
        const x = (this.radius * Math.cos(i) + this.centerX) + this.getRandomRadiusModifier()
        const y = (this.radius * Math.sin(i) + this.centerY) + this.getRandomRadiusModifier()
        this.pathCoordinates.push({ x, y })
        if (i + this.vertixCountFactor >= 2 * Math.PI) {
          this.pathCoordinates.push(this.pathCoordinates[0])
        }
      };
    },
    getRandomRadiusModifier () {
      let num = Math.floor(Math.random() * this.shapeWeirdness) + 1
      num *= Math.floor(Math.random() * 2) === 1 ? 1 : -1
      return num
    },
    resetPathData () {
      this.pathD = ''
      this.pathCoordinates = []
    },
    catmullRom2bezier () {
      let d = ''
      this.pathCoordinates.forEach((coord, index, array) => {
        const p = []
        if (index === 0) {
          d += `M${coord.x},${coord.y} `
          p.push(array[array.length - 3])
          p.push(array[index])
          p.push(array[index + 1])
          p.push(array[index + 2])
        } else if (index === array.length - 2) {
          p.push(array[index - 1])
          p.push(array[index])
          p.push(array[index + 1])
          p.push(array[0])
        } else if (index === array.length - 1) {
          return
        } else {
          p.push(array[index - 1])
          p.push(array[index])
          p.push(array[index + 1])
          p.push(array[index + 2])
        }
        const bp = []
        bp.push({ x: p[1].x, y: p[1].y })
        bp.push({ x: ((-p[0].x + 6 * p[1].x + p[2].x) / 6), y: ((-p[0].y + 6 * p[1].y + p[2].y) / 6) })
        bp.push({ x: ((p[1].x + 6 * p[2].x - p[3].x) / 6), y: ((p[1].y + 6 * p[2].y - p[3].y) / 6) })
        bp.push({ x: p[2].x, y: p[2].y })
        d += 'C' + bp[1].x + ',' + bp[1].y + ' ' + bp[2].x + ',' + bp[2].y + ' ' + bp[3].x + ',' + bp[3].y + ' '
      })
      return d
    },
    drawCurvyShape () {
      this.pathD = this.catmullRom2bezier()
    },
    generateCurvyShape () {
      this.resetPathData()
      this.generateCoords()
      this.drawCurvyShape()
    }
  },
  mounted () {
    this.generateCurvyShape()
  },
  watch: {
    // whenever question changes, this function will run
    currentMouseX: function (newMouseX, oldMouseX) {
      this.generateCurvyShape()
    }
  }
}
</script>

<style lang="scss">

.img-fluid {
  max-width: 100%;
}

.blob {
  transition: all 0.3s ease-out;
  filter:
    invert(0.5)
    sepia(1)
    hue-rotate(200deg)
    saturate(4)
    brightness(1);
}

</style>
